export default __webpack_public_path__ + "static/media/pro-elevate-bbl-banner-1.26c8954a.jpg";